// extracted by mini-css-extract-plugin
export var bounce = "_k1-1";
export var generatingText = "_k1-6";
export var lightning = "_k1-4";
export var popup = "_k1-5";
export var progressBar = "_k1-7";
export var progressFill = "_k1-8";
export var progressShimmer = "_k1-9";
export var progressText = "_k1-a";
export var shimmer = "_k1-3";
export var uploadIcon = "_k1-0";
export var uploadingText = "_k1-2";